var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"error"},[_c('div',{staticClass:"icon"},[_c('b-icon',{attrs:{"icon":"cancel","size":"is-large"}})],1),_c('h1',[_vm._v(" "+_vm._s(_vm.message)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }